import React from 'react';

module.exports = React.createClass({
    render: function() {

        var showText = this.props.EnableMenuText ;
        var liconStyle = {
            /*float: "left",*/
            flex: "0 1 auto",
            WebkitFlex:"0 1 auto",
            visibility: this.props.licon ? "visible" : "hidden",
            padding: '18px',
            paddingBottom: '16px'
        };
        var riconStyle = {
            //float: "right",
            flex: "0 1 auto",
            WebkitFlex:"0 1 auto",
            visibility: this.props.ricon ? "visible" : "hidden",
            padding: '18px',
            paddingBottom: '16px'
        };

        var licon = "fa hc-fa-medium hc-fa-action " + (this.props.licon ? this.props.licon : 'fa-fw');
        var ricon = "fa hc-fa-medium hc-fa-action " + (this.props.ricon ? this.props.ricon : 'fa-fw');

        var liconValueStyle = {
            visibility: showText ? "visible" : "hidden",
            display: showText ? "inline" : "none",
            color: licon.indexOf('hc-fa-action-disabled') < 0 ? '#30ae97' : '#5f6876'
        };
        var riconValueStyle = {
            visibility: showText ? "visible" : "hidden",
            display: showText ? "inline" : "none",
            marginRight: showText ? "1rem" : "0rem",
            color: ricon.indexOf('hc-fa-action-disabled') < 0 ? '#30ae97' : '#5f6876'
        };

        var leftDiv = {};
        var rightDiv = {marginLeft: showText ? "3rem" : "1rem"};
        if (this.props.licon)
            leftDiv.cursor = "pointer";
        if (this.props.ricon)
            rightDiv.cursor = "pointer";

        //HACK for navigation button.
        //TODO: FIX ME
        if (this.props.licon == 'fa-bars' && $(window).width() > 1024) {
            leftDiv.cursor = undefined;
        }
        var panelStyle = {position:'relative', height: "60px", textAlign: "center", whiteSpace: "nowrap", alignContent: "stretch", WebkitAlignContent: 'stretch'}
        var dropdownStyle = {
            height: "60px",
            width: "60px",
            position: "absolute",
            right: "0px",
            border: 0,
            top: 0,
            background: "transparent"
        };
        var dropdownBtnStyle = {
            height: '60px',
            width: '60px',
            padding: 0,
            background: "transparent",
            border: 0,
            lineHeight: 0,
            outline: 0,
            boxShadow: "none",
            marginTop: '2px'
        };

        var rbutton;
        if (this.props.rbutton) {
            var i = 0;
            var items = this.props.rbutton.items.map(function(o) {
                var className = o.icon ? "fa hc-fa-medium hc-fa-action " + o.icon : "";
                var action = o.action;
                if (o.disabled) {
                    className += " hc-fa-action-disabled";
                    action = null;
                }
                return (
                    <li className="hc-menu-btn-active-item" key={++i} onClick={o.action}>
                        <a href="#"><i className={className}
                                       style={{marginRight:"1rem", width:"18px", lineHeight:"40px", verticalAlign:"sub"}}></i>{o.name}
                        </a>
                    </li>)
            });

            rbutton = (
                <div className="dropdown" style={dropdownStyle}>
                    <button className="btn dropdown-toggle fa hc-fa-medium hc-fa-action fa-ellipsis-v hc-hover" type="button" data-toggle="dropdown" style={dropdownBtnStyle}/>
                    <ul className="dropdown-menu  dropdown-menu-right"
                        style={{backgroundColor:"#E9EFEE", border:0, margin:0, borderRadius:0, padding:0}}>
                    {items}
                </ul>
            </div>)
        }

        return (
            <div className="hc-bb hc-flex-display hc-no-print" style={panelStyle}>
                <div className="hc-hover" style={leftDiv} onClick={this.liconClick}><i className={licon} style={liconStyle}></i><span className="hc-f2" style={liconValueStyle}>{this.props.liconText}</span></div>
                <span className="hc-f2" id="mainheader" style={{marginTop:'16px', flex: "1 1 auto", WebkitFlex:"1 1 auto", whiteSpace: "nowrap", overflow:"hidden", textOverflow: "ellipsis", width:"50px"}}>{this.props.text}</span>
                <div className="hc-hover" style={rightDiv} onClick={this.riconClick}><i className={ricon} style={riconStyle}></i><span className="hc-f2" style={riconValueStyle}>{this.props.riconText}</span></div>
                {rbutton}
            </div>
        );
    },

    liconClick: function(o) {
        o.stopPropagation();
        if (this.props.onLiconClick)
            this.props.onLiconClick();
    },

    riconClick: function() {
        if (this.props.onRiconClick)
            this.props.onRiconClick();
    },
});


// WEBPACK FOOTER //
// ./toppanel.js